import React, { useRef } from "react";

import styles from "./DesignSettingBrandColorsPreview.module.css";
import "./DesignSettingsBrandColorsPreview.css";
import AppConstants from "@/constants/AppConstants";
import PreviewArea from "@/components/designchooser/PreviewArea";
import { recursivelyCopySyncedPropsToMobile } from "@/utils/SyncUtils";
import DesignSettingsColorPalette from "./DesignSettingsColorPalette";
import { Button, Text } from "@showitinc/showit-wc";
import HelpTooltip from "../HelpTooltip";

/**
 * DesignSettingBrandColorsPreview renders the mobile and desktop previews of a design and a CTA footer.
 *
 * @typedef {Object} DesignSettingBrandColorsPreviewProps
 * @property {Object} [preview] - Preview data containing blocks, theme, and config.
 * @property {string} [designURL] - URL to load in the preview.
 */
const DesignSettingBrandColorsPreview = ({ preview, setTheme }) => {
  const previewContentRef = useRef(null);
  const desktopWrapperRef = useRef(null);
  const mobileWrapperRef = useRef(null);

  const [theme] = recursivelyCopySyncedPropsToMobile(preview?.theme);

  return (
    <div className={`site-preview ${styles["site-preview-container"]}`}>
      <div className={styles["preview-content"]} ref={previewContentRef}>
        <div className={styles["color-palette-column"]}>
          <div className={styles["preview-buttons"]}>
            <Text className={`${styles["panel-subheading"]} panel-subheading`}>
              Colors
            </Text>
            <HelpTooltip tooltipKey="design-color-palette" placement="right" />
          </div>
          <DesignSettingsColorPalette theme={theme} setTheme={setTheme} />
        </div>

        <div className={"mobile-column"} ref={mobileWrapperRef}>
          <Button
            variant="text"
            className={styles["preview-buttons"]}
            iconPrefix="mobileDevice"
          >
            <Text className={styles["preview-labels"]} variant="body-base">
              &nbsp;Mobile Preview
            </Text>
          </Button>
          <div className={"radius-container"}>
            <PreviewArea
              pageStyle={{
                paddingTop: 0,
                paddingBottom: 0,
                pageBottomOffset: -130,
              }}
              theme={theme}
              preview={preview}
              layout={AppConstants.LAYOUT_MOBILE}
            />
          </div>
        </div>
        <div className={"desktop-column"} ref={desktopWrapperRef}>
          <Button
            variant="text"
            className={styles["preview-buttons"]}
            iconPrefix="desktopDevice"
          >
            <Text className={styles["preview-labels"]} variant="body-base">
              &nbsp;Desktop Preview
            </Text>
          </Button>
          <div className={"radius-container"}>
            <PreviewArea
              pageStyle={{
                paddingTop: 0,
                paddingBottom: 0,
                pageBottomOffset: -130,
              }}
              theme={theme}
              preview={preview}
              layout={AppConstants.LAYOUT_DESKTOP}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DesignSettingBrandColorsPreview;
